// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"409":"cbb1d393","444":"b63e7df7","978":"4fe1c1d0"}[chunkId] + ".chunk.css";
};